import { useAsync } from '../lib/useAsync';
import { trpc } from '../lib/trpc';

/**
 * FRESCOR DO DADO — mostra há quanto tempo a carteira foi atualizada (última
 * importação confirmada). Até 14 dias: nota discreta em verde. Acima de 14
 * dias: aviso para re-enviar a planilha (dados de pagamento podem estar
 * defasados). Acima de 30 dias vira ALERTA (entra no semáforo de prontidão
 * quando ele existir). Não renderiza nada se a carteira nunca foi importada.
 */
function textoDias(d: number): string {
  if (d <= 0) return 'hoje';
  if (d === 1) return 'ontem (há 1 dia)';
  return `há ${d} dias`;
}

export function FrescorBanner() {
  const { data } = useAsync(() => trpc.frescor.query());
  if (!data || data.diasDesde == null) return null;
  const d = data.diasDesde;

  if (d <= 14) {
    return (
      <div className="mb-4 flex items-center gap-2 text-xs text-ink-3" data-testid="frescor-ok">
        <span className="h-1.5 w-1.5 rounded-full" style={{ background: 'var(--accent-bright)' }} aria-hidden="true" />
        Carteira atualizada {textoDias(d)}.
      </div>
    );
  }

  const alerta = d > 30; // acima de 30 dias = alerta (não só aviso)
  const cor = alerta ? 'var(--risk)' : '#b45309';
  const fundo = alerta ? 'var(--risk-soft)' : 'rgba(180, 83, 9, 0.08)';
  return (
    <div
      className="mb-4 flex flex-col gap-1 rounded-sm border px-4 py-3 text-sm sm:flex-row sm:items-center sm:justify-between"
      style={{ borderColor: cor, background: fundo, color: 'var(--ink-2)' }}
      data-testid="frescor-aviso"
    >
      <span>
        <strong style={{ color: cor }}>Carteira atualizada {textoDias(d)}.</strong> Dados de pagamento podem estar
        defasados. Re-envie sua planilha para manter o agente preciso.
      </span>
    </div>
  );
}
